export default function (state, value) {
    state.loading = false;
    state.article = [];
    state.video = [];
}